export default "__VITE_ASSET__Bd208eBD__"